import { URL_LABEL } from "../../../../content/index.content";

const monthlyReportsAndTrends = ({ language, isSavedUser }) => {
  return {
    title: "Monthly Reports & Trends",
    subtitle:
      "Monthly reports about new Amazon trends and product ideas with tips for starting and increasing sales",
    href: `/app/#/reports/reports/?${URL_LABEL}`,
    isBlank: true,
  };
};

export default monthlyReportsAndTrends;
